import React, { useState, useEffect } from 'react'
import { Button, Grid } from '@mui/material'
import { generateReport } from '../../dashboard/functions/generateReport'
import ModalAusencia from './components/ModalAusencia'
import {
  AdaptativeGridContainer,
  DefaultPainel
} from '../../../components/shared'
import Dater from '../../../services/DateFormat'
import { Relatorios } from '../../../services/http'
import TableRelatorioGestao from './components/TableRelatorioGestao'
import TableHeader from '../../../components/shared/tables/TableHeader'
import gerarPaginacao from '../../../services/pagination'
import { any, string } from 'prop-types'
import formatFilter from '../functions'
import PrivateRC from '../../../components/PrivateRC'
import Icons from './components/Icons'
import ModalProcessar from './components/ModalProcessar'
import MobileFilterHeaderContainer from '../../../components/filters/MobileFilterHeaderContainer'

const GeraIcons = value => {
  return Icons[value]
}

const RelatorioLeitura = ({ filter, libName }) => {
  const [query, setQuery] = useState({})
  const [filters, setFilters] = useState({})
  const [status, setStatus] = useState(false)
  const [rows, setRows] = useState([])

  const [lastPage, setLastPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const tableRelations = {
    'includes[leitor][biblioteca_id]': 'biblioteca',
    'includes[leitor][user_id]': 'user_id',
    ano: 'ano'
  }

  const [tableLabel, setTableLabel] = useState('')

  useEffect(() => {
    if (libName === undefined) {
      setTableLabel('')
      return
    }
    setTableLabel(libName)
  }, [libName])

  const getRelations = async (filters = {}, page = 1) => {
    const { data } = await Relatorios().show({
      'includes[leitor.user][ativo]': 'true',
      page,
      ...filters
    })

    setCurrentPage(data.current_page)
    setLastPage(data.last_page)
    const arr = data.data.map((item, index) => ({
      ...item,
      id: index,
      leitor: item.leitor.user.name,
      resultado_nota: item.resultado_nota + '%'
    }))
    setRows(arr)
  }

  useEffect(() => {
    if ('ano' in filter) {
      setQuery(Object.assign(query, { ...filter }))
      setQuery({ ...query, ...filter })
      getRelations(formatFilter(filter, tableRelations))
    }
  }, [filter])

  const geraColunas = () => {
    const meses = Dater().meses

    const columns = meses.map(item => {
      const mes = item.nome.toLowerCase()
      return {
        field: mes,
        headerName: 'Jan',
        flex: 1,
        renderCell: ({ row }) => {
          return GeraIcons(row[mes])
        }
      }
    })
    return columns
  }

  const columns = [
    {
      field: 'leitor',
      headerName: 'Leitor',
      flex: 3
    },
    {
      field: 'janeiro',
      headerName: 'Jan',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.janeiro)
      }
    },
    {
      field: 'fevereiro',
      headerName: 'Fev',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.fevereiro)
      }
    },
    {
      field: 'marco',
      headerName: 'Mar',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.marco)
      }
    },
    {
      field: 'abril',
      headerName: 'Abr',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.abril)
      }
    },
    {
      field: 'maio',
      headerName: 'Mai',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.maio)
      }
    },
    {
      field: 'junho',
      headerName: 'Jun',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.junho)
      }
    },
    {
      field: 'julho',
      headerName: 'Jul',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.julho)
      }
    },
    {
      field: 'agosto',
      headerName: 'Ago',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.agosto)
      }
    },
    {
      field: 'setembro',
      headerName: 'Set',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.setembro)
      }
    },
    {
      field: 'outubro',
      headerName: 'Out',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.outubro)
      }
    },
    {
      field: 'novembro',
      headerName: 'Nov',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.novembro)
      }
    },
    {
      field: 'dezembro',
      headerName: 'Dez',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.dezembro)
      }
    }
  ].map(item => {
    return {
      ...item,
      headerClassName: 'styledHeader',
      sortable: false,
      align: 'center'
    }
  })

  useEffect(() => {
    geraColunas()
  }, [])

  useEffect(() => {
    const aux = {
      ...filters,
      created_at: `${
        query.year?.$y || Dater().formatar(new Date(), 'yyyy')
      }-01-01,${
        query.year
          ? parseInt(query.year?.$y) + 1
          : parseInt(Dater().formatar(new Date(), 'yyyy')) + 1
      }-01-01`,
      year: query.year?.$y
    }

    setFilters(Object.assign(filters, { ...aux }))
  }, [query])

  const pagination = gerarPaginacao(
    true,
    lastPage,
    currentPage,
    (event, value) => getRelations(formatFilter(filter, tableRelations), value)
  )

  const [ausenciaModal, setAusenciaModa] = useState(false)
  return (
    <>
      <DefaultPainel sx={{ mt: '4vh', p: 2 }}>
        <AdaptativeGridContainer>
          <>
            <Grid item xs={12} sm={12}>
              <TableHeader
                titulo={`Gestão de leituras: ${tableLabel} `}
                controls={
                  <MobileFilterHeaderContainer>
                    <PrivateRC roles="bibliotecario">
                      <ModalAusencia
                        bibliotecaName={tableLabel}
                        status={ausenciaModal}
                        setStatus={value => setAusenciaModa(value)}
                        query={query}
                      />
                    </PrivateRC>
                    <PrivateRC roles="bibliotecario">
                      <Button
                        color="white"
                        onClick={async () => {
                          generateReport({
                            ano: query.ano,
                            biblioteca: query.biblioteca
                          })
                        }}
                      >
                        Ver relatório em PDF
                      </Button>
                    </PrivateRC>
                    <PrivateRC roles="gestor">
                      <ModalProcessar
                        status={status}
                        query={query}
                        setStatus={value => setStatus(value)}
                      />
                    </PrivateRC>
                  </MobileFilterHeaderContainer>
                }
              />

              <TableRelatorioGestao
                columns={columns}
                rows={rows}
                rowsPerPageOptions={[10]}
                disableColumnMenu
                disableColumnSelector
                pagination={pagination}
              />
            </Grid>
          </>
        </AdaptativeGridContainer>
      </DefaultPainel>
    </>
  )
}
RelatorioLeitura.propTypes = {
  filter: any,
  libName: string,
  leitor: any
}
export default RelatorioLeitura
